import axios from "axios";
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
if (localStorage.user) {
  let user = JSON.parse(localStorage.user);
  const openId = user ? user.openId : "";
  const token = user ? user.token : "";
  const agentId = user ? user.agentId : "";
  agentId && (axios.defaults.headers.agentId = agentId);
  openId && (axios.defaults.headers.OpenId = openId);
  token && (axios.defaults.headers.Token = token);
}

// export const a = function (data){
//   return axios.get(`${process.env.SEARCH_URL}/`, { params: data })
// }
// 商品 start =======================
// 上架埋点
export const createdCourse = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/createGoodsInfos`, data)
}

// 下架埋点
export const deletedCourse = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/deleteGoodsInfo/batch`, data)
}

// 编辑埋点
export const updatedCourse = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/updateGoodsInfo/${data}`)
}
// 商品 end ========================

// 资讯 start =================
// 添加
export const addNews = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/createInformation/${data}`)
}
// 编辑
export const editNews = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/updateInformation/${data}`)
}
// 删除
export const delNews = function (data){
  return axios.post(`${process.env.SEARCH_URL}/search/deleteInformation/batch`, data)
}
// 资讯 end ===================

// 题库 start =================

// 题库 end ===================

// export const c = function(data){
//   return axios.put(`${process.env.SEARCH_URL}/`, data);
// }

// export const d = function(data) {
//   return axios.delete(`${process.env.SEARCH_URL}/`, { data });
// }


// WEBPACK FOOTER //
// ./src/api/es-search.js